// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min'
import router from './router'
import 'swiper/dist/js/swiper.min.js'
import 'swiper/dist/css/swiper.min.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import store from './store'
// 文件上传组件
import uploader from 'vue-simple-uploader'
import SlideVerify from 'vue-monoplasty-slide-verify'

import './assets/css/global.css' /* 引入公共样式 */
import VideoPlayer from 'vue-video-player'
import webName from './webName'

// 天润统计
import { changeHeader } from '@/api/statistics/index'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
Vue.use(uploader)
Vue.prototype.axios = axios
Vue.use(ElementUI)
Vue.use(SlideVerify)
Vue.config.productionTip = false
/* eslint-disable no-new */

let newName = webName.url
let newId = webName.siteId

// 报名项目
let base = process.env.NODE_ENV === 'production' ? 'https://kepudasai.cdstm.cn/prod-api/devlop-apply' : '/prod-api/devlop-apply'
Vue.prototype.baseURL = base

// 系统项目
let systemApi = process.env.NODE_ENV === 'production' ? 'https://kepudasai.cdstm.cn/prod-api/system' : '/prod-api/system'
Vue.prototype.systemURL = systemApi

// 站点管理项目
let siteApi = process.env.NODE_ENV === 'production' ? 'https://kepudasai.cdstm.cn/prod-api/ruoyi-site' : '/prod-api/ruoyi-site'
Vue.prototype.siteURL = siteApi

// 获取token
let authApi = process.env.NODE_ENV === 'production' ? 'https://kepudasai.cdstm.cn/prod-api/' : '/prod-api'
Vue.prototype.authURL = authApi

// 文件上传地址
Vue.prototype.uploadUrl = process.env.NODE_ENV === 'production' ? 'https://kepudasai.cdstm.cn/prod-api/system/fileUpload/fileUpload/' : '/prod-api/system/fileUpload/fileUpload/'
Vue.prototype.normalUploadUrl = process.env.NODE_ENV === 'production' ? 'https://kepudasai.cdstm.cn/prod-api/system/fileUpload/uploadField/' : '/prod-api/system/fileUpload/uploadField/'
Vue.prototype.batchNormalUploadUrl = process.env.NODE_ENV === 'production' ? 'https://kepudasai.cdstm.cn/prod-api/system/fileUpload/batchUploadField/' : '/prod-api/system/fileUpload/batchUploadField/'
// 站点id
// Vue.prototype.siteId = 25
// Vue.prototype.siteId = 26
Vue.prototype.siteId = 95

// websocket地址 /prod-socket对应nginx配置，如果连接报错需要调整代理路径
Vue.prototype.wsPath = `${process.env.NODE_ENV === 'production' ? 'wss' : 'ws'}://${process.env.NODE_ENV === 'production' ? location.host : '127.0.0.1:9201'}${process.env.NODE_ENV === 'production' ? '/prod-socket' : ''}/websocket/`

const whiteList = ['/mediaCenter', '/images', '/voides', '/news', '/registrationSuccess']
let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)

// 百度统计
var _hmt = _hmt || []
window._hmt = _hmt; // 修改为window 全局变量
(function () {
  var hm = document.createElement('script')
  hm.src = 'https://hm.baidu.com/hm.js?96986b0236d2f9a8970cfd6e4d0cddde'
  var s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(hm, s)
})()

router.beforeEach((to, from, next) => {
  // 天润统计，改变head中的meta
  changeHeader('1', '1', ' 2 ', to.query.id || 'xxx')

  // 百度统计
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }

  if (store.state.pwoerMenuIds.length == 0 || whiteList.indexOf(to.path) != -1) {
    if (flag) {
      if (to.path == '/') {
        next({ path: '/phone' })
      } else {
        next()
      }
    } else {
      next()
    }
  } else {
    if (store.state.pwoerMenuIds.urlList.indexOf(to.path) == -1 && !to.query.id && to.path != '/preliminaryApply') {
      if (flag) {
        next()
      } else {
        next('/')
      }
    } else {
      if (to.matched.some(res => res.meta.requireAuth)) { // 验证是否需要登陆
        if (sessionStorage.getItem('user')) { // 查询本地存储信息是否已经登陆
          if (flag) {
            if (to.path == '/') {
              next({ path: '/phone' })
            } else {
              next()
            }
          } else {
            next()
          }
        } else {
          store.commit('loginVisibleMutations', true)
          if (flag) {
            if (to.path == '/') {
              next({ path: '/phone' })
            } else {
              next()
            }
          } else {
            next({
              path: from.fullPath // 未登录则不跳转
              // query: {redirect: to.fullPath} // 登陆成功后回到当前页面，这里传值给login页面，to.fullPath为当前点击的页面
            })
          }
        }
      } else {
        if (flag) {
          if (to.path == '/') {
            next({ path: '/phone' })
          } else {
            next()
          }
        } else {
          next()
        }
      }
    }
  }
})

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js